import Constant from '@/const';
import axios from 'axios';

const getDrugsById = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/master/drugs/${id}`),
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default getDrugsById;
